import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthStates, useAuthState } from '@vis-auth/react';
import LoaderIcon from 'uswds/dist/img/loader.svg';
import { GlobalHeader } from '@ver-uds/react';
import { InternalRoutes } from '../constants';
import logo from './ClientMou/logo.png';

export interface PublicRouteProps extends RouteProps {
  path: string | string[];
  exact?: boolean;
  conditionToShow?: boolean;
}
const PublicRoute = ({ path, exact = false, conditionToShow = true, children }: PublicRouteProps): JSX.Element => {
  const { state } = useAuthState();

  // Show loader if authentication is still processing
  if (state === AuthStates.authenticating) {
    return (
      <div className="margin-top-4 margin-bottom-3">
        Loading… <img src={LoaderIcon} alt="" className="height-2" />
      </div>
    );
  }

  // Do not show header nav links to unauthenticated session
  if (conditionToShow) {
    return (
      <>
        <GlobalHeader logo={<img src={logo} alt="E-Verify logo" />} />
        <Route path={path} exact={exact} render={() => children} />
      </>
    );
  }
  return <Redirect to={InternalRoutes.PAGE_NOT_FOUND} />;
};

export default PublicRoute;
